import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { DocsContent } from './docs-content/index.js';
import { DocsTree } from './docs-tree/index.js';
import { useStyles } from './styles.js';

export function DocsPage() {
    const styles = useStyles();
    const { path } = useSearch({ from: '/' });
    const navigate = useNavigate();

    const handleSelect = useCallback(
        (selectedPath: string) => {
            navigate({ to: '/', search: { path: selectedPath } });
        },
        [navigate]
    );

    return (
        <div className={styles.container}>
            <PanelGroup autoSaveId="docs-viewer" direction="horizontal">
                <Panel defaultSize={25} minSize={15}>
                    <div className={styles.panel}>
                        <DocsTree onSelect={handleSelect} />
                    </div>
                </Panel>
                <PanelResizeHandle className={styles.resizeHandle} />
                <Panel minSize={30}>
                    <div className={styles.panel}>
                        <DocsContent selectedPath={path} onNavigate={handleSelect} />
                    </div>
                </Panel>
            </PanelGroup>
        </div>
    );
}
